import React from "react"
import { ContactPersonType } from "../../types/mainModulTypes"
import { API } from "../../constants/constants"
import MailButton from "../common/MailButton"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseRichtext from "../common/BaseRichtext"
import { ReactComponent as CONTACT } from "../../assets/contact.svg"

export default function ContactPerson(props: ContactPersonType) {
    const imageSide = (side: string): string => {
        if (side?.includes("Right")) return "flex-col-reverse sm:flex-row"
        if (side?.includes("Left")) return "flex-col-reverse sm:flex-row-reverse "
        return ""
    }

    const imagePosition = (position: string): string => {
        if (position?.includes("Top")) return "sm:-mt-48"
        if (position?.includes("Bottom")) return "sm:-mb-48"
        return ""
    }

    const numbers = props.contactPersonContact?.mainPhone?.split(',')?.map(num => num.trim())?.filter(num => num !== '');

    const landline = numbers && numbers[0] ? numbers[0] : "";
    const mobile = numbers && numbers[1] ? numbers[1] : "";

    return (
        <div className={`max-w-content mx-auto w-full flex gap-4 sm:gap-8 justify-between ${imageSide(props?.contactPersonImageSide)} px-4 pb-4`}>
            <div className="flex-grow pl-1 sm:pl-16 sm:flex gap-8 items-start sm:pt-4 md:pt-16">
                <div>
                    <BaseSubheadline label={"Ansprechpartner"} classProps="pb-4 !text-2xl" />
                    <div className="flex sm:block flex-wrap gap-x-2">
                        <BaseRichtext classProps="!text-lg font-semibold" content={props?.contactPersonContact?.position + ":"} />
                        <BaseRichtext content={
                            [props?.contactPersonContact?.title, props?.contactPersonContact?.fullName]
                                .filter(Boolean)
                                .join(" ")
                        } classProps="!text-lg pb-4" />
                    </div>
                    {/* <BaseRichtext content={props.contactPersonInformation} classProps="pb-6" /> */}
                    {/* <BaseRichtext content={"Tel: " + props.contactPersonContact?.mainPhone} /> */}

                    {landline &&
                        <BaseRichtext
                            linksNotInPrimary
                            content={
                                "Tel: <a href='tel:" + landline + "'>" + landline + "</a>"
                            }
                            classProps="!text-base"
                        />
                    }
                    {mobile &&
                        <BaseRichtext
                            linksNotInPrimary
                            content={
                                "Mobil: <a href='tel:" + mobile + "'>" + mobile + "</a>"
                            }
                            classProps="!text-base"
                        />
                    }
                    {props.contactPersonContact?.mainFax &&
                        <BaseRichtext linksNotInPrimary content={"Fax: " + props.contactPersonContact?.mainFax} classProps="!text-base" />
                    }
                    {props.contactPersonContact?.mainEmail &&
                        <BaseRichtext
                            linksNotInPrimary
                            content={
                                "E-Mail: <a href='mailto:" + props.contactPersonContact?.mainEmail + "'>" + props.contactPersonContact?.mainEmail + "</a>"
                            }
                            classProps="pb-6 !text-base"
                        />
                    }
                    <div className="flex flex-col sm:flex-row sm:gap-2 items-start">
                        <BaseRichtext content={"Standort:"} classProps="font-semibold !text-base" />
                        <div className="">
                            {props.contactPersonContact?.mainAddress?.addition &&
                                <BaseRichtext
                                    classProps="!text-base"
                                    content={props.contactPersonContact?.mainAddress?.addition}
                                />
                            }
                            <BaseRichtext
                                classProps="!text-base"
                                content={props.contactPersonContact?.mainAddress?.street + " " + props.contactPersonContact?.mainAddress?.number}
                            />
                            <BaseRichtext
                                classProps="!text-base"
                                content={props.contactPersonContact?.mainAddress?.zip + " " + props.contactPersonContact?.mainAddress?.city}
                            />
                        </div>
                    </div>
                    <MailButton
                        mail={props.contactPersonContact?.mainEmail}
                        classParent="pt-4 sm:hidden"
                        classProps="w-full sm:w-fit justify-center"
                    />
                </div>
                <CONTACT
                    className={`w-24 object-contain pt-12 ${props.contactPersonIconColor ? "fill-accent" : "fill-primary"} ${props.contactPersonIcon ? "hidden sm:block" : "hidden"
                        }`}
                />
            </div>
            <div className={`  relative sm:w-5/12 flex flex-col items-start sm:items-center ${imagePosition(props?.contactPersonImageOverlap)}`}>
                <img
                    src={API + props?.contactPersonContact?.avatar?.url}
                    alt={props.contactPersonContact?.avatar?.description ?? props.contactPersonContact?.avatar?.name}
                    className=" w-32 h-32 sm:w-auto sm:h-auto rounded-full sm:aspect-[4/6] border-4 object-cover sm:rounded-default border-accent"
                />
                <div className="relative -translate-y-1/2 hidden sm:block">
                    <MailButton mail={props.contactPersonContact?.mainEmail} />
                </div>
            </div>
        </div>
    )
}
